import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';

import updateChannel from 'widget/redux/server/actions/channel/update';
import WixSDK from 'shared/utils/wix-sdk';

import DataComponent from 'shared/data-components/_data-component';


@connect(state => ({
  currentChannelId: state.currentChannelId,
}), {
  updateChannel,
})
export default class UpdateChannelPublishedState extends DataComponent {
  static displayName = 'UpdateChannelPublishedState';

  static propTypes = {
    currentChannelId: PropTypes.string,
    updateChannel: PropTypes.func,
  };

  @autobind
  handleSitePublish() {
    const { currentChannelId, updateChannel } = this.props;

    if (!currentChannelId) {
      return;
    }

    updateChannel({
      id: currentChannelId,
      onPublishedSite: true,
    });
  }

  componentDidMount() {
    WixSDK.addEventListener(WixSDK.Events.SITE_PUBLISHED, this.handleSitePublish);
  }

  componentWillUnmount() {
    WixSDK.removeEventListener(WixSDK.Events.SITE_PUBLISHED, this.handleSitePublish);
  }

  get childProps() {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/widget/data-components/update-channel-published-state.js